<template>
    <button
        type="button"
        class="h-auto flex items-center font-oceanside font-semibold capitalize text-[14px]"
    >
        <img
            :src="imageUrl"
            :alt="iconName"
            class="mr-[19px]"
            :class="{
                'w-[20px] h-auto': iconName === 'email' || iconName === 'print' || iconName === 'heart' || iconName === 'link',
            }"
        >

        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            iconName: {
                type: String,
                required: true,
            },
        },

        computed: {
            imageUrl() {
                let iconUrl = '';

                if (this.iconName === 'check') {
                    iconUrl = new URL('../../assets/images/icons/check-filled.svg', import.meta.url);
                } else if (this.iconName === 'link') {
                    iconUrl = new URL('../../assets/images/icons/link.svg', import.meta.url);
                } else if (this.iconName === 'black-check') {
                    iconUrl = new URL('../../assets/images/icons/check-filled.svg', import.meta.url);
                } else if (this.iconName === 'email') {
                    iconUrl = new URL('../../assets/images/icons/email.svg', import.meta.url);
                } else if (this.iconName === 'print') {
                    iconUrl = new URL('../../assets/images/icons/print.svg', import.meta.url);
                } else if (this.iconName === 'heart') {
                    iconUrl = new URL('../../assets/images/icons/heart.svg', import.meta.url);
                }

                return iconUrl;
            },
        },
    };
</script>
